// @flow

import type {
  ActionHandlers,
  Reducer,
  Selector,
} from '@travel-frontend/state-handling-sdk';
import type {FetchTourOperatorDescriptionSuccess} from 'redux/tourOperator/actions';
import type {DescriptionItem} from 'redux/tourOperator/models';
import type {TourOperatorState} from 'redux/tourOperator/TourOperatorState';

import {
  createReducerUsingActionHandlers,
  ERROR,
  PENDING,
  SUCCESS,
} from '@travel-frontend/state-handling-sdk';
import {createSelector} from 'reselect';

import {tourOperatorState} from 'redux/ApplicationRedux';
import {FETCH_TOUR_OPERATOR_DESCRIPTION} from 'redux/tourOperator/actions';

export const initialState: TourOperatorState = {
  loading: false,
};

const actionCreators: ActionHandlers<TourOperatorState> = {
  [PENDING(FETCH_TOUR_OPERATOR_DESCRIPTION)]: (state: TourOperatorState) => ({
    ...state,
    loading: true,
  }),
  [SUCCESS(FETCH_TOUR_OPERATOR_DESCRIPTION)]: (
    state: TourOperatorState,
    action: FetchTourOperatorDescriptionSuccess
  ) => ({
    ...state,
    loading: false,
    data: action.data,
  }),
  [ERROR(FETCH_TOUR_OPERATOR_DESCRIPTION)]: (
    state: TourOperatorState,
    action: any
  ) => ({
    ...state,
    loading: false,
    error: action?.error,
  }),
};

export const tourOperatorReducer: Reducer<TourOperatorState> = // $FlowIgnore
  createReducerUsingActionHandlers<TourOperatorState>(
    initialState,
    actionCreators
  );

export const isDataLoaded: Selector<boolean> = createSelector(
  tourOperatorState,
  (state: TourOperatorState) =>
    !state.loading && state.data !== undefined
);

export const getTourOperatorDescription: Selector<DescriptionItem[]> =
  createSelector(
    [tourOperatorState, isDataLoaded],
    (state: TourOperatorState, loaded: boolean) =>
      loaded && state.data ? state.data : []
  );
